export const BIGQUERY_LOCATION_OPTIONS = [
  { label: "US - Data centers in the United States", value: "US" },
  {
    label: "EU - Data centers within member states of the European Union",
    value: "EU",
  },
  { label: "us-east1 - South Carolina", value: "us-east1" },
  { label: "us-east4 - Northern Virginia", value: "us-east4" },
  { label: "us-east5 - Columbus, Ohio", value: "us-east5" },
  { label: "us-central1 - Iowa", value: "us-central1" },
  { label: "us-south1 - Dallas", value: "us-south1" },
  { label: "us-west1 - Oregon", value: "us-west1" },
  { label: "us-west2 - Los Angeles", value: "us-west2" },
  { label: "us-west3 - Salt Lake City", value: "us-west3" },
  { label: "us-west4 - Las Vegas", value: "us-west4" },
  {
    label: "northamerica-northeast1 - Montréal",
    value: "northamerica-northeast1",
  },
  {
    label: "northamerica-northeast2 - Toronto",
    value: "northamerica-northeast2",
  },
  { label: "asia-east1 - Taiwan", value: "asia-east1" },
  { label: "asia-east2 - Hong Kong", value: "asia-east2" },
  { label: "asia-northeast1 - Tokyo", value: "asia-northeast1" },
  { label: "asia-northeast2 - Osaka", value: "asia-northeast2" },
  { label: "asia-northeast3 - Seoul", value: "asia-northeast3" },
  { label: "asia-south1 - Mumbai", value: "asia-south1" },
  { label: "asia-south2 - Delhi", value: "asia-south2" },
  { label: "asia-southeast1 - Singapore", value: "asia-southeast1" },
  { label: "asia-southeast2 - Jakarta", value: "asia-southeast2" },
  { label: "australia-southeast1 - Sydney", value: "australia-southeast1" },
  { label: "australia-southeast2 - Melbourne", value: "australia-southeast2" },
  { label: "europe-central2 - Warsaw", value: "europe-central2" },
  { label: "europe-north1 - Finland", value: "europe-north1" },
  { label: "europe-southwest1 - Madrid", value: "europe-southwest1" },
  { label: "europe-west1 - Belgium", value: "europe-west1" },
  { label: "europe-west12 - Turin", value: "europe-west12" },
  { label: "europe-west2 - London", value: "europe-west2" },
  { label: "europe-west3 - Frankfurt", value: "europe-west3" },
  { label: "europe-west4 - Netherlands", value: "europe-west4" },
  { label: "europe-west6 - Zürich", value: "europe-west6" },
  { label: "europe-west8 - Milan", value: "europe-west8" },
  { label: "europe-west9 - Paris", value: "europe-west9" },
  { label: "me-central1 - Doha", value: "me-central1" },
  { label: "me-central2 - Dammam", value: "me-central2" },
  { label: "me-west1 - Tel Aviv", value: "me-west1" },
  { label: "southamerica-east1 - São Paulo", value: "southamerica-east1" },
  { label: "southamerica-west1 - Santiago", value: "southamerica-west1" },
];
